import React from "react";
import Card from "../../../../componets/Card";
import { AddonInterface } from "../../../../store/mods_factory/addonsSlice";

const _Details = ({ addon }: { addon: AddonInterface | undefined }) => {
  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Search text</h4>
        {addon?.search_text}
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Body Content</h4>
        {addon?.description}
      </Card>
    </>
  );
}

export default _Details;
